import { render, staticRenderFns } from "./VoucherProductSelection.vue?vue&type=template&id=1858054e&scoped=true"
import script from "./VoucherProductSelection.vue?vue&type=script&lang=js"
export * from "./VoucherProductSelection.vue?vue&type=script&lang=js"
import style0 from "./VoucherProductSelection.vue?vue&type=style&index=0&id=1858054e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1858054e",
  null
  
)

export default component.exports